import Dexie from 'dexie';
import { ESharedFunction } from 'motw_core/Enums/ESharedFunction';
import { ReadState } from '../../services/UI/State/ReadState';
import { SetState } from '../../services/UI/State/SetState';

class MotwIndexedDb extends Dexie {
	States: Dexie.Table<any, string>;

	constructor() {
		super(`motwIndexedDb`);
		this.version(1).stores({
			States: ', state'
		});
    }
}

const db = new MotwIndexedDb();

export async function LoadComponentStateAsync(component: React.Component<any, any>) {
    const result = await db.States.get(component.constructor.name)
    
    if (result) {
        component.setState(result);
    }
}

export async function SaveComponentStateAsync(component: React.Component<any, any>) {
    await db.States.put(component.state, component.constructor.name);
}

export async function LoadStateAsync(func: ESharedFunction) {
    const result = await db.States.get(ESharedFunction[func])
    
    if (result) {
        SetState(func, result);
    }
}

export async function SaveStateAsync(func: ESharedFunction) {
    await db.States.put(ReadState(func), ESharedFunction[func]);
}


export async function DeleteDatabaseAsync() {
    db.delete();
}